export const photos = {
    SEARCH_ICON: 'https://p0.meituan.net/travelcube/20cedfd450e06a9260d775e1a634bdac2015.png',
    WHITE_ICON_DOWN: 'https://p0.meituan.net/travelcube/953f6ff893fa3f138dee478b56dc1016759.png',
    GREY_ICON_DOWN: 'https://p1.meituan.net/travelcube/dce17fb1988de168f04d7426f966177c1592.png',
    BLACK_ICON_DOWN: 'https://p0.meituan.net/ingee/1f50cc9d39074344db543a6115395f05882.png',
    QUESTION_MARK: 'https://p0.meituan.net/travelcube/f610dbda81049aa98c4494298b36731b1117.png',
    BLUE_RIGHT_ARROW: 'https://p0.meituan.net/travelcube/09accd7f95f4498a7395d773bee43628458.png',
    CLOSE_ICON: 'https://p0.meituan.net/travelcube/cb0a0d5f24e2d7b5300e931209e2db1d743.png',
    REFRESH_ICON: 'https://p1.meituan.net/travelcube/8c6d5a21b2e2f7481242228e7268f8921448.png',
    LOCATION_ICON: 'https://p0.meituan.net/travelcube/0f4080a961100ddc78a4ce33a98d4ade1108.png',
    BUTTON_SELECTED: 'https://p0.meituan.net/ingee/4e9a0021035847ec62d6c38b9a871aea998.png',
    AREA_NOT_FOUND: 'https://p0.meituan.net/travelcube/18381003590d63358f310f8a5801e512163558.png',
    ALL_BOOKED: 'https://p0.meituan.net/travelcube/9924a5215c6195375ff567ea23a93f7b11410.png',
    POI_TAG: 'https://p0.meituan.net/travelcube/e956a5a60e17d4307898661b327f199a2259.png'
};
export const CHECKIN_CHECKOUT_ENUM = {
    CHECKIN: 'checkin',
    CHECKOUT: 'checkout'
};
